import { Pipe, PipeTransform } from '@angular/core';
import { TimerIndex, TimerIndexDescriptions } from '../enums/timer-index.enum';

@Pipe({
  name: 'timerIndex',
  standalone: false,
})
export class TimerIndexPipe implements PipeTransform {
  transform(value: number | undefined): string {
    if (value == null) return '';

    return TimerIndexDescriptions[Number(value) as TimerIndex];
  }
}